import React, { useContext } from "react";
import usePartners from "../hooks/usePartners";

const PartnerContext = React.createContext({
  isPartner: false,
  createNickname: async (nickname: string): Promise<boolean> => false,
  getAddressByNickname: async (nickname: string): Promise<string> => "",
});

const PartnerProvider = ({ children }) => {
  const {
    isPartner,
    createNickname,
    getAddressByNickname
  } = usePartners({ onlyPartner: true, disableChainCalls: true });

  return (
    <PartnerContext.Provider
      value={{
        isPartner,
        createNickname: async (nickname: string) => {
          return await createNickname(nickname);
        },
        getAddressByNickname: async (nickname: string) => {
          return await getAddressByNickname(nickname);
        }
      }}
    >
      {children}
    </PartnerContext.Provider>
  );
};

export { PartnerContext, PartnerProvider }; 